<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['NOME', 'NOME DE USUÁRIO', 'EMAIL CORPORATIVO', 'ADMINISTRADOR', 'AÇÕES']"
            :showNew="true"
            :showReload="true"
            :showSearch="true"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="(obj.inative || obj.blocked) ? 0 : 1" :value="obj.pessoa && obj.pessoa.nome ? obj.pessoa.nome.toUpperCase() : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="(obj.inative || obj.blocked) ? 0 : 1" :value="obj.username" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="(obj.inative || obj.blocked) ? 0 : 1" :value="obj.pessoa && obj.pessoa.emailCorporativo ? obj.pessoa.emailCorporativo : 'N/D'" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="(obj.inative || obj.blocked) ? 0 : 1" :value="obj.administrador ? 'SIM' : 'NÃO'" />
        <td class="row d-flex justify-content-center">
          <template>
            <div v-if="obj.inative">
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                  <i class="fa fa-check cursor-pointer" style="color: black;" :title="$lang.Accounts.AtiveUserToolTip"></i>
                </template>
                <b-dropdown-header><strong>{{$lang.Accounts.ConfirmActiveUser}}</strong></b-dropdown-header>
                <b-dropdown-item href="javascript:void(0);" v-on:click="changeUserStatus(obj, 'false')">{{$lang.Common.Yes}}</b-dropdown-item>
                <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
              </b-dropdown>
            </div>
            <div v-if="!obj.inative">
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                  <i class="fas fa-ban text-third cursor-pointer" style="color: red;" :title="$lang.Accounts.InativeUserToolTip"></i>
                </template>
                <b-dropdown-header><strong>{{$lang.Accounts.ConfirmInativeUser}}</strong></b-dropdown-header>
                <b-dropdown-item href="javascript:void(0);" v-on:click="changeUserStatus(obj, 'true')">{{$lang.Common.Yes}}</b-dropdown-item>
                <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
          <div style="width: 1rem;"></div>
          <template>
            <div v-if="obj.blocked">
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                  <i class="fa fa-lock-open cursor-pointer" style="color: black;" :title="$lang.Accounts.UnblockUserToolTip"></i>
                </template>
                <b-dropdown-header><strong>{{$lang.Accounts.ConfirmUnblockUser}}</strong></b-dropdown-header>
                <b-dropdown-item href="javascript:void(0);" v-on:click="toggleUserBlock(obj, 'false')">{{$lang.Common.Yes}}</b-dropdown-item>
                <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
              </b-dropdown>
            </div>
            <div v-if="!obj.blocked">
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                  <i class="fas fa-lock text-third cursor-pointer" style="color: red;" :title="$lang.Accounts.BlockUserToolTip"></i>
                </template>
                <b-dropdown-header><strong>{{$lang.Accounts.ConfirmBlockUser}}</strong></b-dropdown-header>
                <b-dropdown-item href="javascript:void(0);" v-on:click="toggleUserBlock(obj, 'true')">{{$lang.Common.Yes}}</b-dropdown-item>
                <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </td>
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo Usuário</span></button>
      </div>
    </div>
    <SidebarSearch @search="onSearch" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import AccountRepository from '@/shared/http/repositories/configurations/account.js'
import { advancedOnException } from '@/components/tools/Utils'
import SidebarSearch from '@/views/private/configurations/account/components/search/SidebarUsuarios.vue'

export default {
  name: 'AccountList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  components: {SidebarSearch},
  methods: {
    onNew () {
      this.$emit('New')
    },
    onLoad () {
      this.onLoadAll()
    },
    toggleUserBlock (obj, status) {
      loading.push()
      let data = {
        blocked: status
      }
      AccountRepository.ChangeStatus(obj.id, data)
        .then(() => {
          this.onLoadAll()
          loading.pop()
        })
        .catch(e => advancedOnException(e, this.$lang))
    },
    changeUserStatus (obj, status) {
      loading.push()
      let data = {
        inative: status
      }
      AccountRepository.ChangeStatus(obj.id, data)
        .then(() => {
          this.onLoadAll()
          loading.pop()
        })
        .catch(e => advancedOnException(e, this.$lang))
    },
    onLoadAll () {
      loading.push()
      if (this.filters && this.filters.name) {
        AccountRepository.Search(this.filters.name, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        AccountRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/account/components/list/accountlist.vue